module.exports = __webpack_public_path__ + "static/media/marketing-feature-tile-icon-02.934c0b5d.svg";